<template>

    <div class="md_login-panel">
        <div class="wrap">

            <!-- Input -->
            <form class="input-wrap" v-on:submit.prevent="submit">
                <div class="inner">

                    <div class="group _start">

                        <h2><span>Login</span></h2>
                        <div class="item form_text" v-if="showNotice">{{ noticeMessage }}</div>

                        <!-- Email -->
                        <div class="item form_text">
                            <input type="email" id="email" placeholder=" " v-model="form.email">
                            <label for="email" class="m-label"><span>Email</span></label>
                        </div>

                        <!-- Password -->
                        <div class="item form_text">
                            <input type="password" id="password" placeholder=" " v-model="form.password">
                            <label for="password" class="m-label"><span>Password</span></label>
                        </div>

                        <!-- ログイン情報を保存する -->
                        <div class="item form_checkbox">
                            <input type="checkbox" name="password-save" class="" id="password-save" v-model="form.remember">
                            <label for="password-save">
                                <div class="check-mark"><span></span></div>
                                <span>ログイン情報を保存する</span>
                            </label>
                        </div>
                    </div>

                    <div class="group _end">
                        <div class="item">
                            <!-- パスワードを忘れた方はこちら -->
                            <Link v-if="canResetPassword" :href="route('password.request')" class="md_text-link">
                                <span>パスワードを忘れた方はこちら</span>
                            </Link>
                        </div>
                        <div class="btn_link-wrap _w100">
                            <button type="submit" class="btn_link" v-bind:disabled="form.processing"><span>ログイン</span></button>
                            <div class="bg-element"></div>
                        </div>
                    </div>

                </div>
            </form>

            <!-- Img -->
            <div class="img-wrap">
                <img src="/img/login-panel.jpg" alt="">
            </div>

        </div>
        <!-- BgText -->
        <div class="bg-text"><span>User Login</span></div>

        <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
            不要コードここから
        :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::-->

        <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
            不要コードここまで
        :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::-->

    </div>
    <AlertModal 
        v-if="showAlertModal" 
        @close="closeAlertModal" 
        :title="alert_modal_title" 
        :message="alert_modal_message"
        :mode="alert_modal_mode" 
    />
</template>

<script>
    import { defineComponent } from 'vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import AlertModal from '@/components/EndUser/ComponentList/AlertModal'

    //Common
    import EndUserLayout from '@/Layouts/EndUserLayout'
    import likeMixins from '@/common/like.js'

    export default defineComponent({
        //Common
        mixins: [likeMixins],
        layout: EndUserLayout,
        components: {
            JetValidationErrors,
            Link,
            "AlertModal": AlertModal,
        },

        props: {
            canResetPassword: Boolean,
            status: String
        },

        data() {
            return {
                form: {
                    email: '',
                    password: '',
                    remember: false,
                    noticeMessage: '',
                    showAlertModal: false,
                    alert_modal_title: '',
                    alert_modal_message: '',
                    alert_modal_mode: ''
                }
            }
        },
        mounted() {
            this.form.processing = false;
            if(this.$page.props.flash.success?.length > 0){
                const successMessage = this.$page.props.flash.success.split(",");
                this.openAlertModal("success", successMessage[0], successMessage[1]);
            }
        },
        methods: {
            autoLogin(email) {
                this.form.email = email;
                this.form.password = 'password';
                this.submit();
            },
            submit() {
                // this.form
                //     .transform(data => ({
                //         ... data,
                //         remember: this.form.remember ? 'on' : ''
                //     }))
                //     .post(this.route('login'), {
                //         onFinish: () => {
                //             this.form.reset('password')
                //         },
                //     })
                if (this.form.remember) {
                    this.form.remember = 'on';
                } else {
                    this.form.remember = '';
                }
                this.form.processing = true;
                axios.post(route('login'), this.form)
                .then((res) => {
                    // ローカルのライクをユーザーに結びつける
                    const likes = likeMixins.methods.getLikes();
                    axios.post(route('set.like.relation'), {likes: likes})
                    .then((res) => {
                        likeMixins.methods.clearLikes();
                        localStorage.setItem('showHamburgerMenuAfterLogin', 'true');
                        location.reload();
                    }).catch(error => {
                        this.openAlertModal('error', 'エラー', error); // 確認済み
                        this.form.processing = false;
                        location.href = route('logout');
                    });
                }).catch(error => {
                    if (error.response.status == 422) {
                        this.openAlertModal('error', 'エラー', 'メールアドレスまたはパスワードに誤りがあるか、登録されていません。'); // 確認済み
                    }
                    this.form.processing = false;
                });
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            }
        },
        computed: {
            showNotice() {
                if (location.href.match(/before/)) {
                    this.noticeMessage = 'ログインが必要です';
                    return true;
                }
            }
        }
    })
</script>
